import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import NsContent from 'components/common/ns-content/NsContent';

import { MeterReadSelector } from 'components/direct-sales/user-preferences/components/MeterReadSelector';
import { NsList } from 'components/common/ns-list/NsList';
import { useHasSmartMeter } from 'components/direct-sales/quote/hooks/useHasSmartMeter';
import { FUEL_TYPES, METER_READ_TYPES } from 'config/app-config';
import { useCurrentProduct } from 'components/direct-sales/quote/hooks/useCurrentProduct';
import { setMeterReadPreferences } from 'state/user-preferences/user-preferences-slice';
import { pushEvent } from 'state/analytics/analytics-slice';

export const testId = 'meterReadPreferencesTestId';

export const MeterReadPreferences = () => {
  const dispatch = useDispatch();
  const { isTOU } = useCurrentProduct();
  const { hasElectricitySmartMeter, hasGasSmartMeter } = useHasSmartMeter();
  const smartMeterByFuel = [
    ...(hasElectricitySmartMeter ? [FUEL_TYPES.ELECTRIC] : []),
    ...(hasGasSmartMeter ? [FUEL_TYPES.GAS] : [])
  ];
  const hasNoSmartMeter = !hasElectricitySmartMeter && !hasGasSmartMeter;
  const shouldNotRender = hasNoSmartMeter || isTOU;

  useEffect(() => {
    if (isTOU) {
      smartMeterByFuel.forEach((fuel) => {
        dispatch(
          setMeterReadPreferences({
            fuel,
            value: METER_READ_TYPES.HALF_HOURLY
          })
        );
        dispatch(
          pushEvent({
            category: 'portal_smartmeter_frequency_final',
            action: fuel,
            label: METER_READ_TYPES.HALF_HOURLY
          })
        );
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (shouldNotRender) {
    return null;
  }

  return (
    <div data-testid={testId}>
      <NsContent>
        <h2>Choose how often your meters send readings</h2>
        <NsList className="ul-bullet">
          {[
            `The more often your smart meters send us readings, the easier it is 
            for you to see how much energy you’re using.`,
            `This can help manage your energy usage, potentially cutting costs.`,
            `We may use half-hourly data to offer you tailored energy products 
            and services.`,
            `Remember, it's your data and you're always in control and your 
            settings can be changed at any time in your account.`
          ]}
        </NsList>
        <MeterReadSelector
          fuel={
            hasElectricitySmartMeter && hasGasSmartMeter
              ? 'dual'
              : smartMeterByFuel[0]
          }
          smartMeterByFuel={smartMeterByFuel}
        />{' '}
        <br />
      </NsContent>
    </div>
  );
};
